import React, { useState, useEffect, useContext } from 'react';
import {
    Container, Box, TextField, Button, Dialog, DialogContent, DialogTitle, FormControl, Select,
    DialogActions, Grid, MenuItem, IconButton, InputAdornment, Tooltip, Typography, Tabs, Tab,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Stack, Accordion,
    AccordionDetails, AccordionSummary, Checkbox, Autocomplete, RadioGroup, FormControlLabel,
    Radio, FormLabel, Grow
} from '@mui/material';
import Swal from 'sweetalert2';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import axios from 'axios';
import ReusableTable from '../components/tables/resuabletable';
import * as XLSX from 'xlsx';
import { AuthContext } from '..';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import format, { formatDate } from 'date-fns/format';
import jsPDF from 'jspdf';
import SendIcon from '@mui/icons-material/Send';
import MailOutlineIcon from '@mui/icons-material/MailOutline'
import DownloadIcon from '@mui/icons-material/Download';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CancelIcon from '@mui/icons-material/Cancel';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import html2canvas from "html2canvas";
import autoTable from 'jspdf-autotable'
import { parse, isValid } from 'date-fns';
import { FollowTheSigns } from '@mui/icons-material';
import { display } from '@mui/system';


export default function FollowUps() {
    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);
    const [openFollowUpDialog, setOpenFollowUpDialog] = useState(false);
    const [openCustomDialog, setOpenCustomDialog] = useState(false);
    const [selectedFollowUp, setSelectedFollowUp] = useState(null);
    const [editingFollowUpId, setEditingFollowUpId] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [employeelist, setEmployeelist] = useState([]);
    const [leadslist, setLeadslist] = useState([]);
    const [services, setServices] = useState([]);
    const [pdf, setPdf] = useState(true);
    const { companyid, leadStageData, companydata, permissions, selfOnly, employeeId, token } = useContext(AuthContext);
    const [invoicedialog, setInvoicedialog] = useState(false);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [openPreview, setOpenPreview] = useState(false);
    const [editicon, setEditicon] = useState(true);
    const [deleteiocn, setDeleteicon] = useState(true);
    const [expand, setExpand] = useState(false);
    const [appliedFilters, setAppliedFilters] = useState([]);
    const [opencolspaper, setOpencolspaper] = useState(false);
    const [columnOrder, setColumnOrder] = useState([]);
    const [negotiate, setNegotiate] = useState('No');
    const [newDiscount, setNewDiscount] = useState(0);
    const [selectedLeadDiscount, setSelectedLeadDiscount] = useState(0);
    const [taxOption, setTaxOption] = useState('including');
    const [roundOff, setRoundOff] = useState(0);
    const [openServiceDialog, setOpenServiceDialog] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);
    const [wantAddServices, setWantAddServices] = useState('No');
    const [selectedLead, setSelectedLead] = useState(null);
    const [employeeid, setEmployeeid] = useState('');
    const popup = true;
    const [background, setBackground] = useState(null)
    const [openEmailDialog, setOpenEmailDialog] = useState(false);
    const [emailSubject, setEmailSubject] = useState('');
    const [emailContent, setEmailContent] = useState('');




    const filteredColumns = columnOrder
        .map(field => columns.find(col => col.field === field))
        .filter(col => col && !col.hide);

    const [pagination, setPagination] = useState({
        page: 0,
        rowsPerPage: 25,
    });
    const [totalrows, setTotalrows] = useState(0);

    const handlePaginationChange = (paginationData) => {
        setPagination(paginationData);
    };

    const [formData, setFormData] = useState({
        companyid: companyid,
        leadId: '',
        followUpDate: null,
        followUpTime: '',
        assignedTo: '',
        status: '',
        notes: '',
        nextFollowUpDate: null,
        negotiate: 'No',
        wantAddServices: 'No',
        taxOption: 'including',
        roundOff: null,
        discount: 0,
        original_taxableAmount: 0,
        original_taxAmount: 0,
        original_totalAmount: 0,
        revised_taxableAmount: 0,
        revised_taxAmount: 0,
        revised_totalAmount: 0,
        services: [],
        revisedAmounts: []
    });



    const handleOpenEmailDialog = (followUp) => {
        setSelectedFollowUp(followUp);
        setEmailSubject(`Follow-up Details for ${followUp.lead_name} - ${new Date().toISOString().split('T')[0]}`);
        setEmailContent(
            `Dear ${followUp.full_name || followUp.lead_name},\n\n` +
            `We hope this message finds you well. Attached are the details for your follow-up, including services, dates, and financial summary.\n\n` +
            `Please review the attached PDF for complete details. Feel free to reach out if you have any questions or require further assistance.\n\n` +
            `Best regards,\n${companydata[0]?.companyname || 'Your Company Name'}`
        );
        setOpenEmailDialog(true);
    };

    const handleCloseEmailDialog = () => {
        setOpenEmailDialog(false);
        setEmailSubject('');
        setEmailContent('');
        setSelectedFollowUp(null);
    };

    const handleSendEmail = () => {
        if (!emailSubject.trim()) {
            Swal.fire('Error', 'Subject is required', 'error');
            return;
        }
        if (!emailContent.trim()) {
            Swal.fire('Error', 'Email content is required', 'error');
            return;
        }
        handlePdf(selectedFollowUp, 'send', emailSubject);
        handleCloseEmailDialog();
    };



    const [errors, setErrors] = useState({});

    const validate = () => {
        const newErrors = {};
        if (!formData.leadId) newErrors.leadId = "Lead selection is required";
        if (!formData.followUpDate) newErrors.followUpDate = "Follow-up date is required";
        if (!formData.status) newErrors.status = "Status is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const permissionsaccess = () => {
        const followupmodule = permissions.followup || {};
        setDeleteicon(followupmodule.delete === true);
        setEditicon(followupmodule.update === true);
    };

    const computeAmounts = () => {
        let subtotal = 0;
        let taxAmount = 0;
        let totalAmount = 0;

        formData.services.forEach(service => {
            const serviceAmounts = calculateServiceAmount(service);
            subtotal += parseFloat(serviceAmounts.baseAmount);
            taxAmount += parseFloat(serviceAmounts.taxAmount);
            totalAmount += parseFloat(serviceAmounts.totalAmount);
        });

        const discountPct = parseFloat(negotiate === 'Yes' ? newDiscount : selectedLeadDiscount) || 0;
        const discountAmount = parseFloat(totalAmount * (discountPct / 100));
        const totalAfterDiscount = parseFloat(totalAmount - discountAmount);

        const originalTaxable = parseFloat(subtotal);
        const originalTax = parseFloat(taxAmount);
        const originalTotal = parseFloat(totalAmount);

        let revisedTaxable = originalTaxable;
        let revisedTax = originalTax;
        let revisedTotal = totalAfterDiscount;

        if (negotiate === 'Yes' && formData.roundOff > 0) {
            const taxPercentage = parseFloat((originalTax / originalTaxable || 0) * 100);
            if (taxOption === 'including') {
                revisedTaxable = parseFloat(formData.roundOff / (1 + (taxPercentage / 100)) || 1);
                revisedTax = parseFloat(formData.roundOff - revisedTaxable);
                revisedTotal = parseFloat(formData.roundOff);
            } else {
                revisedTax = parseFloat(formData.roundOff * (taxPercentage / 100));
                revisedTotal = parseFloat(formData.roundOff + revisedTax);
                revisedTaxable = parseFloat(formData.roundOff);
            }
        }

        const revisedAmountsArray = [
            { description: 'Original Total Amount', amount: originalTotal.toFixed(2) },
            { description: 'Original Taxable Amount', amount: originalTaxable.toFixed(2) },
            { description: 'Original Tax Amount', amount: originalTax.toFixed(2) },
            { description: 'Tax Percentage', amount: `${((originalTax / originalTaxable || 0) * 100).toFixed(2)}%` },
            { description: 'Revised Base Amount', amount: revisedTaxable.toFixed(2) },
            { description: 'Revised Tax Amount', amount: revisedTax.toFixed(2) },
            { description: 'Final Total Amount', amount: revisedTotal }
        ];

        return {
            original_taxableAmount: originalTaxable,
            original_taxAmount: originalTax,
            original_totalAmount: originalTotal,
            revised_taxableAmount: revisedTaxable,
            revised_taxAmount: revisedTax,
            revised_totalAmount: revisedTotal,
            revisedAmounts: revisedAmountsArray
        };
    };

    useEffect(() => {
        if (formData.services.length > 0) {
            const amounts = computeAmounts();
            setFormData(prev => ({
                ...prev,
                ...amounts,
                roundOff: prev.roundOff
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                original_taxableAmount: 0,
                original_taxAmount: 0,
                original_totalAmount: 0,
                revised_taxableAmount: 0,
                revised_taxAmount: 0,
                revised_totalAmount: 0,
                revisedAmounts: [],
                discount: 0,
                roundOff: prev.roundOff
            }));
        }
    }, [formData.services, negotiate, newDiscount, selectedLeadDiscount, taxOption, formData.roundOff]);

    useEffect(() => {
        if (companyid) {
            setFormData(prev => ({
                ...prev,
                companyid: companyid
            }));
            fetchFollowUps();
            fetchServices();
            fetchEmployees();
            fetchLeads();
        }
    }, [companyid, appliedFilters, pagination]);

    useEffect(() => {
        if (permissions && permissions.followup) {
            permissionsaccess();
        }
    }, [permissions]);

    useEffect(() => {
        if (negotiate === 'Yes' && newDiscount === 0) {
            setNewDiscount(selectedLeadDiscount);
            setFormData(prev => ({
                ...prev,
                discount: selectedLeadDiscount
            }));
        } else if (negotiate === 'No') {
            setFormData(prev => ({
                ...prev,
                discount: selectedLeadDiscount
            }));
        }
    }, [negotiate, selectedLeadDiscount]);

    const fetchEmployees = () => {
        axios.get(`${process.env.REACT_APP_API_LINKS}/employees/getemployees`, {
            headers: {
                Authorization: `bearer ${token}`
            },
            withCredentials: true
        })
            .then((res) => {
                setEmployeelist(res.data.data);
            })
            .catch((error) => {
                console.error('Error fetching employees:', error);
            });
    };

    const fetchLeads = () => {
        const payload = { module: true, selfOnly: selfOnly, employeeid: employeeId };
        axios.get(`${process.env.REACT_APP_API_LINKS}/leads/getcompanyleads/${companyid}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: payload,
            withCredentials: true
        })
            .then((res) => {
                setLeadslist(res.data.data);
            })
            .catch((error) => {
                console.error('Error fetching leads:', error);
            });
    };

    const fetchServices = () => {
        axios.get(`${process.env.REACT_APP_API_LINKS}/services/getservices`, {
            headers:
            {
                Authorization: `bearer ${token}`
            },
            withCredentials: true
        })
            .then(res => {
                if (Array.isArray(res.data.data)) {
                    const values = res.data.data;
                    const list = values.filter((el) => el.status != 'inactive')
                    setServices(list);
                } else {
                    setServices([]);
                }
            })
            .catch(err => {
                console.error('Failed to fetch services:', err);
            });
    };

    const fetchFollowUps = () => {
        const payload = {
            filters: JSON.stringify(appliedFilters),
            currentpage: pagination.page,
            rowsPerPage: pagination.rowsPerPage,
            selfOnly: selfOnly,
            employeeid: employeeId
        };

        axios.get(`${process.env.REACT_APP_API_LINKS}/followups/getfollowups/`, {
            headers: {
                Authorization: `bearer ${token}`
            },
            params: payload,
            withCredentials: true
        })
            .then((res) => {
                const newColumns = res.data.columns.map((col) => {
                    if (col.field === "followUpDate") return { ...col, field: "display_followUpDate" };
                    if (col.field === "nextFollowUpDate") return { ...col, field: "display_nextFollowUpDate" };
                    if (col.field === "created_at") return { ...col, field: "display_created_at" };
                    if (col.field === "updated_at") return { ...col, field: "display_updated_at" };
                    return col;
                });

                setColumns(newColumns);
                setColumnOrder(newColumns.filter(col => !col.hide).map(col => col.field));

                const numberoffollowups = res.data.totalrows[0];
                setTotalrows(numberoffollowups.totalusers);

                const data = res.data.data;

                const formattedRows = data.map(followUp => {

                    let servicesArray = [];

                    try {
                        if (typeof followUp.services === 'string') {
                            const parsedOnce = JSON.parse(followUp.services);
                            servicesArray = typeof parsedOnce === 'string' ? JSON.parse(parsedOnce) : parsedOnce;
                        } else if (Array.isArray(followUp.services)) {
                            servicesArray = followUp.services;
                        }
                    } catch (e) {
                        console.error('Error parsing services:', e, followUp.services);
                    }
                    if (servicesArray.length === 0) {
                        setPdf(false)
                    }
                    else {
                        setPdf(true)
                    }

                    const formattedServices = servicesArray.map(service => ({
                        ...service,
                        start_date: service.start_date ? format(new Date(service.start_date), 'yyyy-MM-dd') : '',
                        display_start_date: service.start_date ? format(new Date(service.start_date), 'dd/MM/yyyy') : '',
                        end_date: service.end_date ? format(new Date(service.end_date), 'yyyy-MM-dd') : '',
                        display_end_date: service.end_date ? format(new Date(service.end_date), 'dd/MM/yyyy') : '',
                        total_amount: service.total_amount || calculateServiceAmount(service).totalAmount
                    }));

                    let revisedAmountsArray = [];
                    try {
                        revisedAmountsArray = typeof followUp.revisedAmounts === 'string'
                            ? JSON.parse(followUp.revisedAmounts)
                            : Array.isArray(followUp.revisedAmounts)
                                ? followUp.revisedAmounts
                                : [];
                    } catch (e) {
                        console.error('Failed to parse revisedAmounts JSON:', e);
                    }

                    return {
                        ...followUp,
                        followUpDate: followUp.followUpDate ? format(new Date(followUp.followUpDate), 'yyyy-MM-dd') : '',
                        display_followUpDate: followUp.followUpDate ? format(new Date(followUp.followUpDate), 'dd/MM/yyyy') : '',
                        nextFollowUpDate: followUp.nextFollowUpDate ? format(new Date(followUp.nextFollowUpDate), 'yyyy-MM-dd') : '',
                        display_nextFollowUpDate: followUp.nextFollowUpDate ? format(new Date(followUp.nextFollowUpDate), 'dd/MM/yyyy') : '',
                        created_at: followUp.created_at ? format(new Date(followUp.created_at), 'yyyy-MM-dd') : '',
                        display_created_at: followUp.created_at ? format(new Date(followUp.created_at), 'dd/MM/yyyy') : '',
                        updated_at: followUp.updated_at ? format(new Date(followUp.updated_at), 'yyyy-MM-dd') : '',
                        display_updated_at: followUp.updated_at ? format(new Date(followUp.updated_at), 'dd/MM/yyyy') : '',
                        services: formattedServices,
                        wantAddServices: followUp.wantAddServices || 'No',
                        negotiate: followUp.negotiate || 'No',
                        taxOption: followUp.taxOption || 'including',
                        roundOff: followUp.roundOff || null,
                        discount: followUp.discount || 0,
                        original_taxableAmount: followUp.original_taxableAmount || 0,
                        original_taxAmount: followUp.original_taxAmount || 0,
                        original_totalAmount: followUp.original_totalAmount || 0,
                        revised_taxableAmount: followUp.revised_taxableAmount || 0,
                        revised_taxAmount: followUp.revised_taxAmount || 0,
                        revised_totalAmount: followUp.revised_totalAmount || 0,
                        revisedAmounts: revisedAmountsArray
                    };
                });

                setRows(formattedRows);
            })
            .catch((error) => {
                console.error('Error fetching follow-ups:', error);
                setRows([]);
            });
    };


    const handleLeadSelect = (event, value) => {
        if (value && !editingFollowUpId) {
            const leadId = value.id;
            setSelectedLead(value);

            setEmployeeid(value.employeeid);

            // Find existing follow-up data for the selected lead
            const followupData = rows.find(data => data.leadId === leadId);

            if (followupData) {
                let services = [];
                try {
                    if (typeof followupData.services === 'string') {
                        services = JSON.parse(followupData.services);
                    } else if (Array.isArray(followupData.services)) {
                        services = followupData.services;
                    }
                } catch (err) {
                    console.error('Error parsing services JSON:', err);
                    services = [];
                }

                // Format services with calculated amounts and proper date objects
                const formattedServices = services.map(s => {
                    const serviceAmounts = calculateServiceAmount(s);
                    return {
                        ...s,
                        total_amount: serviceAmounts.totalAmount,
                        start_date: s.start_date ? new Date(s.start_date) : null,
                        end_date: s.end_date ? new Date(s.end_date) : null,
                    };
                });

                // Update formData with all relevant follow-up data
                setFormData(prev => ({
                    ...prev,
                    leadId: leadId,
                    assignedTo: value.assigned_to || '',
                    services: formattedServices,
                    discount: followupData.discount || 0,
                    wantAddServices: followupData.wantAddServices || 'No',
                    negotiate: followupData.negotiate || 'No',
                    taxOption: followupData.taxOption || 'including',
                    roundOff: followupData.roundOff || null,
                    original_taxableAmount: followupData.original_taxableAmount || 0,
                    original_taxAmount: followupData.original_taxAmount || 0,
                    original_totalAmount: followupData.original_totalAmount || 0,
                    revised_taxableAmount: followupData.revised_taxableAmount || 0,
                    revised_taxAmount: followupData.revised_taxAmount || 0,
                    revised_totalAmount: followupData.revised_totalAmount || 0,
                    // revisedAmounts: followupData.revisedAmounts || [],
                    // followUpDate: followupData.followUpDate ? new Date(followupData.followUpDate) : null,
                    // followUpTime: followupData.followUpTime || '',
                    // status: followupData.status || '',
                    // notes: followupData.notes || '',
                    // nextFollowUpDate: followupData.nextFollowUpDate ? new Date(followupData.nextFollowUpDate) : null,
                }));

                // Update related state variables
                setSelectedLeadDiscount(followupData.discount || 0);
                setWantAddServices(followupData.wantAddServices || 'No');
                setNegotiate(followupData.negotiate || 'No');
                setTaxOption(followupData.taxOption || 'including');
                setRoundOff(followupData.roundOff || null);
                setNewDiscount(followupData.discount || 0);

            } else {
                // No follow-up data found, reset to default
                setFormData(prev => ({
                    ...prev,
                    leadId: leadId,
                    assignedTo: value.assigned_to || '',
                    services: [],
                    discount: 0,
                    wantAddServices: 'No',
                    negotiate: 'No',
                    taxOption: 'including',
                    roundOff: null,
                    original_taxableAmount: 0,
                    original_taxAmount: 0,
                    original_totalAmount: 0,
                    revised_taxableAmount: 0,
                    revised_taxAmount: 0,
                    revised_totalAmount: 0,
                    revisedAmounts: [],
                    followUpDate: null,
                    followUpTime: '',
                    status: '',
                    notes: '',
                    nextFollowUpDate: null,
                }));
                setSelectedLeadDiscount(0);
                setWantAddServices('No');
                setNegotiate('No');
                setTaxOption('including');
                setRoundOff(0);
                setNewDiscount(0);
            }
        } else {
            // When lead selection is cleared
            setSelectedLead(null);
            setEmployeeid('');
            setFormData({
                companyid: companyid,
                leadId: '',
                assignedTo: '',
                services: [],
                discount: 0,
                wantAddServices: 'No',
                negotiate: 'No',
                taxOption: 'including',
                roundOff: null,
                original_taxableAmount: 0,
                original_taxAmount: 0,
                original_totalAmount: 0,
                revised_taxableAmount: 0,
                revised_taxAmount: 0,
                revised_totalAmount: 0,
                revisedAmounts: [],
                followUpDate: null,
                followUpTime: '',
                status: '',
                notes: '',
                nextFollowUpDate: null,
            });
            setSelectedLeadDiscount(0);
            setWantAddServices('No');
            setNegotiate('No');
            setTaxOption('including');
            setRoundOff(0);
            setNewDiscount(0);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleDateChange = (name, date) => {
        setFormData({ ...formData, [name]: date });
    };

    const handleServiceSelect = (event, value) => {
        if (value) {
            const service = services.find(s => s.service_name === value.service_name);
            if (service && !formData.services.some(s => s.service_name === value.service_name)) {
                const newService = {
                    id: service.id,
                    service_name: service.service_name,
                    original_duration: service.duration,
                    duration: service.duration,
                    base_price: service.base_price,
                    tax_rate: service.tax_rate,
                    total_amount: service.base_price,
                    start_date: null,
                    end_date: null
                };
                setFormData(prev => ({
                    ...prev,
                    services: [...prev.services, newService]
                }));
            }
        }
    };

    const handleServiceDateChange = (index, field, date) => {
        const updatedServices = [...formData.services];
        updatedServices[index][field] = date;

        if (field === 'start_date' || field === 'end_date') {
            const service = updatedServices[index];
            if (service.start_date && service.end_date) {
                const startDate = new Date(service.start_date);
                const endDate = new Date(service.end_date);
                const duration = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;

                updatedServices[index].duration = duration;

                // Recalculate the amounts
                const serviceAmounts = calculateServiceAmount({ ...service, duration });
                updatedServices[index].total_amount = serviceAmounts.totalAmount;
            }
        }

        setFormData(prev => ({
            ...prev,
            services: updatedServices
        }));
    };

    const removeService = (serviceId) => {
        setFormData(prev => ({
            ...prev,
            services: prev.services.filter(service => service.id !== serviceId)
        }));
    };

    const calculateServiceAmount = (service) => {
        // Calculate per day cost
        const perDayCost = parseFloat(service.base_price) / parseInt(service.original_duration);

        // Calculate taxable amount based on selected duration
        let taxableAmount = parseFloat(service.base_price); // Default to original amount

        if (service.start_date && service.end_date) {
            const startDate = new Date(service.start_date);
            const endDate = new Date(service.end_date);
            const duration = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;
            taxableAmount = perDayCost * duration;
        }

        // Calculate tax amount
        const taxAmount = taxableAmount * (parseFloat(service.tax_rate) / 100);

        // Calculate total amount
        const totalAmount = taxableAmount + taxAmount;

        return {
            baseAmount: taxableAmount.toFixed(2),
            taxAmount: taxAmount.toFixed(2),
            totalAmount: totalAmount.toFixed(2)
        };
    };

    const handleFollowUpSubmit = () => {
        if (!validate()) {
            return;
        }

        const formattedData = {
            ...formData,
            followUpDate: formData.followUpDate ? format(formData.followUpDate, 'yyyy-MM-dd') : null,
            nextFollowUpDate: formData.nextFollowUpDate ? format(formData.nextFollowUpDate, 'yyyy-MM-dd') : null,
            services: formData.services.map(service => ({
                ...service,
                start_date: service.start_date ? format(new Date(service.start_date), 'yyyy-MM-dd') : '',
                end_date: service.end_date ? format(new Date(service.end_date), 'yyyy-MM-dd') : '',
                total_amount: calculateServiceAmount(service).totalAmount
            })),
            revisedAmounts: JSON.stringify(formData.revisedAmounts),
            assignedTo: employeeid
        };

        if (editingFollowUpId) {
            axios.put(`${process.env.REACT_APP_API_LINKS}/followups/updatefollowup/${editingFollowUpId}`, formattedData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                withCredentials: true,
            })
                .then((res) => {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Follow-up updated successfully',
                        showConfirmButton: false,
                        timer: 1500
                    });
                    setOpenFollowUpDialog(false);
                    setEditingFollowUpId(null);
                    setFormData({
                        companyid: companyid,
                        leadId: '',
                        followUpDate: null,
                        followUpTime: '',
                        assignedTo: '',
                        status: '',
                        notes: '',
                        nextFollowUpDate: null,
                        negotiate: 'No',
                        wantAddServices: 'No',
                        taxOption: 'including',
                        roundOff: null,
                        discount: 0,
                        original_taxableAmount: 0,
                        original_taxAmount: 0,
                        original_totalAmount: 0,
                        revised_taxableAmount: 0,
                        revised_taxAmount: 0,
                        revised_totalAmount: 0,
                        services: [],
                        revisedAmounts: []
                    });
                    setSelectedLead(null);
                    setWantAddServices('No');
                    setNegotiate('No');
                    setNewDiscount(0);
                    setSelectedLeadDiscount(0);
                    setTaxOption('including');
                    setRoundOff(0);
                    fetchFollowUps();
                })
                .catch((err) => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Failed to update follow-up',
                        showConfirmButton: false,
                        timer: 2000
                    });
                });
        } else {
            axios.post(`${process.env.REACT_APP_API_LINKS}/followups/addfollowup`, formattedData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                withCredentials: true,
            })
                .then((res) => {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Follow-up added successfully',
                        showConfirmButton: false,
                        timer: 1500
                    });
                    setOpenFollowUpDialog(false);
                    setFormData({
                        companyid: companyid,
                        leadId: '',
                        followUpDate: null,
                        followUpTime: '',
                        assignedTo: '',
                        status: '',
                        notes: '',
                        nextFollowUpDate: null,
                        negotiate: 'No',
                        wantAddServices: 'No',
                        taxOption: 'including',
                        roundOff: null,
                        discount: 0,
                        original_taxableAmount: 0,
                        original_taxAmount: 0,
                        original_totalAmount: 0,
                        revised_taxableAmount: 0,
                        revised_taxAmount: 0,
                        revised_totalAmount: 0,
                        services: [],
                        revisedAmounts: []
                    });
                    setSelectedLead(null);
                    setWantAddServices('No');
                    setNegotiate('No');
                    setNewDiscount(0);
                    setSelectedLeadDiscount(0);
                    setTaxOption('including');
                    setRoundOff(0);
                    fetchFollowUps();
                })
                .catch((err) => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Failed to add follow-up',
                        showConfirmButton: false,
                        timer: 2000
                    });
                });
        }
    };


    const handleEdit = (followUp) => {

        const employee = employeelist.find(emp => emp.id === followUp.employeeid) || null;

        const selectedLeadObj = leadslist.find(l => l.id === followUp.leadId) || null;

        setEmployeeid(followUp.employeeid || '');

        let services = [];
        try {
            if (typeof followUp.services === 'string') {
                const parsed = JSON.parse(followUp.services);
                services = Array.isArray(parsed) ? parsed : [];
            } else if (Array.isArray(followUp.services)) {
                services = followUp.services;
            }
        } catch (e) {
            console.error('Failed to parse followUp.services:', e);
            services = [];
        }

        const formattedServices = services.map(s => {
            const serviceAmounts = calculateServiceAmount(s);
            return {
                ...s,
                start_date: s.start_date ? parse(s.start_date, 'yyyy-MM-dd', new Date()) : null,
                end_date: s.end_date ? parse(s.end_date, 'yyyy-MM-dd', new Date()) : null,
                total_amount: serviceAmounts.totalAmount,
            };
        });

        let revisedAmounts = [];
        try {
            if (typeof followUp.revisedAmounts === 'string') {
                revisedAmounts = JSON.parse(followUp.revisedAmounts);
            } else if (Array.isArray(followUp.revisedAmounts)) {
                revisedAmounts = followUp.revisedAmounts;
            }
        } catch (e) {
            console.error('Failed to parse followUp.revisedAmounts:', e);
            revisedAmounts = [];
        }

        const parseDate = (dateStr) => {
            if (!dateStr) return null;
            try {
                const parsedDate = parse(dateStr, 'yyyy-MM-dd', new Date());
                return isValid(parsedDate) ? parsedDate : null;
            } catch (e) {
                console.error(`Failed to parse date: ${dateStr}`, e);
                return null;
            }
        };

        const getStatusId = (status) => {
            if (!status || !leadStageData) return '';
            const match = leadStageData.find(item =>
                String(item.value).toLowerCase() === String(status).toLowerCase()
            );
            return match ? match.id : '';
        };

        setFormData({
            companyid: companyid,
            leadId: followUp.leadId || '',
            followUpDate: parseDate(followUp.followUpDate),
            followUpTime: followUp.followUpTime || '',
            assignedTo: employee?.employee_name || followUp.employee_name || '',
            status: getStatusId(followUp.status) || '',
            notes: followUp.notes || '',
            nextFollowUpDate: parseDate(followUp.nextFollowUpDate),
            negotiate: followUp.negotiate || 'No',
            wantAddServices: followUp.wantAddServices || 'No',
            taxOption: followUp.taxOption || 'including',
            roundOff: parseFloat(followUp.roundOff) || 0,
            discount: parseFloat(followUp.discount) || 0,
            original_taxableAmount: parseFloat(followUp.original_taxableAmount) || 0,
            original_taxAmount: parseFloat(followUp.original_taxAmount) || 0,
            original_totalAmount: parseFloat(followUp.original_totalAmount) || 0,
            revised_taxableAmount: parseFloat(followUp.revised_taxableAmount) || 0,
            revised_taxAmount: parseFloat(followUp.revised_taxAmount) || 0,
            revised_totalAmount: parseFloat(followUp.revised_totalAmount) || 0,
            services: formattedServices,
            revisedAmounts: revisedAmounts,
        });

        // Update related state variables
        setSelectedLead(selectedLeadObj);
        setNegotiate(followUp.negotiate || 'No');
        setNewDiscount(parseFloat(followUp.discount) || 0);
        setSelectedLeadDiscount(parseFloat(followUp.discount) || 0);
        setWantAddServices(followUp.wantAddServices || 'No');
        setTaxOption(followUp.taxOption || 'including');
        setRoundOff(parseFloat(followUp.roundOff) || 0);
        setEditingFollowUpId(followUp.id);
        setOpenFollowUpDialog(true);
    };


    const handleDelete = (followUp) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                axios.delete(`${process.env.REACT_APP_API_LINKS}/followups/deletefollowup/${followUp.id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    withCredentials: true,
                })
                    .then(() => {
                        Swal.fire('Deleted!', 'Follow-up has been deleted.', 'success');
                        fetchFollowUps();
                    })
                    .catch(() => {
                        Swal.fire('Error!', 'Failed to delete follow-up.', 'error');
                    });
            }
        });
    };

    const handleSearch = (e) => {
        setSearchQuery(e.target.value.toLowerCase());
    };

    const filteredRows = rows
        .filter((row) => {
            const query = searchQuery.toLowerCase();
            const leadName = row.lead_name?.toLowerCase() || '';
            const status = row.status?.toLowerCase() || '';
            const followUpDate = row.display_followUpDate?.toLowerCase() || '';
            const nextFollowUpDate = row.display_nextFollowUpDate?.toLowerCase() || '';
            const createdAt = row.display_created_at?.toLowerCase() || '';
            const updatedAt = row.display_updated_at?.toLowerCase() || '';
            const servicesDates = row.services?.map(s => s.display_start_date || s.display_end_date).join(' ').toLowerCase() || '';

            return (
                leadName.includes(query) ||
                status.includes(query) ||
                followUpDate.includes(query) ||
                nextFollowUpDate.includes(query) ||
                createdAt.includes(query) ||
                updatedAt.includes(query) ||
                servicesDates.includes(query)
            );
        })
        .map((row) => {

            const filteredRow = { ...row };
            filteredColumns.forEach((col) => {
                filteredRow[col.field] = row[col.field] || '';
            });
            return filteredRow;
        });

    const formatFollowUpsData = (rows) => {
        return rows.map((row, index) => {
            const formattedRow = { S_No: index + 1 };

            filteredColumns.forEach((col) => {
                if (col.headerName === 'S.No') return;

                formattedRow[col.headerName || col.field] = row[col.field] || '';
            });

            return formattedRow;
        });
    };

    const exportToExcel = () => {
        const exportRows = selectedIds.length > 0
            ? rows.filter(row => selectedIds.includes(row.id))
            : filteredRows;

        const exportData = formatFollowUpsData(exportRows).map(row => {
            const { S_No, Next_Follow_Up_Date, ...rest } = row;
            return rest;
        });

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'FollowUps');
        XLSX.writeFile(workbook, 'followups_data.xlsx');
    };


    const handlePdf = async (followUp, invoiceduty, dynamicSubject) => {
        if (!invoiceduty || invoiceduty === "cancel") return;

        try {
            const bankRes = await axios.get(
                `${process.env.REACT_APP_API_LINKS}/settings/bank-account`,
                {
                    headers:
                    {
                        Authorization: `bearer ${token}`
                    },
                    withCredentials: true
                }
            );

            const bankData = bankRes.data?.bankData;

            const settingsRes = await axios.get(`${process.env.REACT_APP_API_LINKS}/settings/getsettings`,
                {
                    headers:
                    {
                        Authorization: `bearer ${token}`
                    },
                    withCredentials: true
                }
            );
            const settings = settingsRes.data;

            const leadRes = await axios.get(`${process.env.REACT_APP_API_LINKS}/leads/getcompanyleads/${followUp.leadId}`, {
                params: { module: false }, withCredentials: true,
                headers: { Authorization: `bearer ${token}` }
            });

            const lead = (leadRes.data.data || [])[0];

            if (!lead) throw new Error("Lead not found");

            const services = Array.isArray(followUp.services) ? followUp.services : [];
            const subtotal = services.reduce((sum, s) => sum + parseFloat(s.total_amount || 0), 0);
            const discount = parseFloat(followUp.discount || lead.discount || 0);
            const discountAmount = subtotal * (discount / 100);
            const total = followUp.revised_totalAmount || subtotal - discountAmount;

            const pdf = new jsPDF("p", "mm", "a4");
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            const marginX = 20;
            const startY = 50;
            const endY = pageHeight - 40;
            let currentY = startY;

            // const checkAddPage = (blockHeight) => {
            //     if (currentY + blockHeight > endY) {
            //         pdf.addPage();
            //         currentY = startY;
            //         if (bgImage.src) pdf.addImage(bgImage, "PNG", 0, 0, pageWidth, pageHeight);
            //         return true;
            //     }
            //     return false;
            // };

            // const bgUrl = `${process.env.REACT_APP_API_LINKS}/headers/${settings?.logo || ''}`;
            // const bgImage = new Image();
            // bgImage.crossOrigin = "anonymous";
            // bgImage.src = bgUrl;
            // const bgLoaded = await new Promise((resolve) => {
            //     bgImage.onload = () => resolve(true);
            //     bgImage.onerror = () => resolve(false);
            // });

            // if (bgLoaded) {
            //     pdf.addImage(bgImage, "PNG", 0, 0, pageWidth, pageHeight);
            // }

            const checkAddPage = (blockHeight = 10) => {
                if (currentY + blockHeight > endY) {
                    pdf.addPage();
                    currentY = startY;

                    if (bgImage) {
                        pdf.addImage(bgImage, "PNG", 0, 0, pageWidth, pageHeight);
                    } else {
                        pdf.setFillColor(255, 255, 255);
                        pdf.rect(0, 0, pageWidth, pageHeight, "F");
                    }
                }
            };

            // Default white background first
            pdf.setFillColor(255, 255, 255);
            pdf.rect(0, 0, pageWidth, pageHeight, "F");

            let bgImage = null;

            // Only try loading image if logo exists
            if (settings && settings.logo) {
                const bgUrl = `${process.env.REACT_APP_API_LINKS}/headers/${settings.logo}`;

                bgImage = new Image();
                bgImage.crossOrigin = "anonymous";
                bgImage.src = bgUrl;

                const bgLoaded = await new Promise((resolve) => {
                    bgImage.onload = () => resolve(true);
                    bgImage.onerror = () => resolve(false);
                });

                if (bgLoaded) {
                    pdf.addImage(bgImage, "PNG", 0, 0, pageWidth, pageHeight);
                }
            }

            pdf.setFont("Times", "bold");
            pdf.setFontSize(18);
            pdf.text("Follow-Up Details", pageWidth / 2, currentY - 10, { align: "center" });

            pdf.setFont("Times", "bold");
            pdf.setFontSize(14);
            const subjectLines = pdf.splitTextToSize(dynamicSubject || `Follow-up Details for ${lead.lead_name}`, pageWidth - 2 * marginX);
            const subjectHeight = subjectLines.length * 5; // 5mm per line (approx for font size 14)
            checkAddPage(subjectHeight);
            pdf.text(subjectLines, marginX, currentY);
            currentY += subjectHeight + 8;

            pdf.setFont("Times", "normal");
            pdf.setFontSize(12);
            const contactHeight = 18; // 3 lines at ~6mm each
            checkAddPage(contactHeight);
            pdf.text(`To: ${lead.full_name || followUp.full_name || ''}`, marginX, currentY);
            pdf.text(`Email: ${lead.email || followUp.email || ''}`, marginX, currentY + 6);
            pdf.text(`Phone: ${lead.phone || followUp.phone || ''}`, marginX, currentY + 12);
            pdf.text(`Follow-up Date: ${followUp.display_followUpDate || '-'}`, pageWidth - marginX, currentY, { align: 'right' });
            pdf.text(`Status: ${followUp.status || '-'}`, pageWidth - marginX, currentY + 6, { align: 'right' });
            currentY += contactHeight + 4;

            const tableColumns = ["Service", "Start Date", "End Date", "Days", "Amount"];
            const tableRows = services.map(s => [
                s.service_name || '-',
                s.display_start_date || '-',
                s.display_end_date || '-',
                s.duration || '-',
                parseFloat(s.total_amount || 0).toFixed(2)
            ]);

            // Calculate table height: header (approx 8mm) + rows (approx 6mm each) + padding
            const tableHeight = 8 + (tableRows.length * 6) + 4;
            checkAddPage(tableHeight);
            autoTable(pdf, {
                startY: currentY,
                head: [tableColumns],
                body: tableRows,
                margin: { left: marginX, right: marginX },
                styles: {
                    font: "times",
                    fontSize: 10,
                    textColor: [0, 0, 0],
                    cellPadding: 3,
                    lineColor: [0, 0, 0],
                    lineWidth: 0.3,
                    overflow: "linebreak",
                    fillColor: null
                },
                headStyles: {
                    fontStyle: "bold",
                    textColor: [0, 0, 0],
                    lineColor: [0, 0, 0],
                    lineWidth: 0.3,
                    halign: "center",
                    fillColor: null
                },
                alternateRowStyles: {
                    fillColor: null
                },
                columnStyles: {
                    0: { cellWidth: 60 },
                    1: { cellWidth: 30 },
                    2: { cellWidth: 30 },
                    3: { cellWidth: 20 },
                    4: { cellWidth: 35, halign: "right" }
                },
                didDrawPage: (data) => {
                    currentY = data.table.finalY;
                }
            });
            currentY = pdf.lastAutoTable.finalY + 12;

            pdf.setFont("Times", "bold");
            pdf.text("Negotiation Details:", marginX, currentY);
            pdf.setFont("Times", "normal");
            const negotiationLines = [
                `Negotiate: ${followUp.negotiate || 'No'}`,
                `Want Additional Services: ${followUp.wantAddServices || 'No'}`,
                `Tax Option: ${followUp.taxOption || 'including'}`,
                `Round Off: ${parseFloat(followUp.roundOff || 0).toFixed(2)}`
            ];
            const negotiationHeight = negotiationLines.length * 5 + 6; // 5mm per line + title
            checkAddPage(negotiationHeight);
            pdf.text(negotiationLines, marginX, currentY + 6);
            currentY += negotiationHeight + 8;

            if (followUp.negotiate === 'Yes') {
                const financialColumns = ["Description", "Amount"];
                const financialRows = [
                    ["Original Taxable Amount", parseFloat(followUp.original_taxableAmount || 0).toFixed(2)],
                    ["Original Tax Amount", parseFloat(followUp.original_taxAmount || 0).toFixed(2)],
                    ["Original Total Amount", parseFloat(followUp.original_totalAmount || 0).toFixed(2)],
                    ["Revised Taxable Amount", parseFloat(followUp.revised_taxableAmount || 0).toFixed(2)],
                    ["Revised Taxable Amount", parseFloat(followUp.revised_taxableAmount || 0).toFixed(2)],
                    ["Revised Taxable Amount", parseFloat(followUp.revised_taxableAmount || 0).toFixed(2)],
                    ["Revised Tax Amount", parseFloat(followUp.revised_taxAmount || 0).toFixed(2)],
                    ["Final Total Amount", parseFloat(followUp.revised_totalAmount || 0).toFixed(2)]
                ];
                // Calculate financial table height: header (8mm) + rows (6mm each) + padding
                const financialTableHeight = 8 + (financialRows.length * 6) + 4;
                checkAddPage(financialTableHeight);
                pdf.setFont("Times", "bold");
                pdf.text("Financial Summary:", marginX, currentY);
                currentY += 6;
                autoTable(pdf, {
                    startY: currentY,
                    head: [financialColumns],
                    body: financialRows,
                    margin: { left: marginX, right: marginX },
                    styles: {
                        font: "times",
                        fontSize: 10,
                        textColor: [0, 0, 0],
                        cellPadding: 3,
                        lineColor: [0, 0, 0],
                        lineWidth: 0.3,
                        overflow: "linebreak",
                        fillColor: null
                    },
                    headStyles: {
                        fontStyle: "bold",
                        textColor: [0, 0, 0],
                        lineColor: [0, 0, 0],
                        lineWidth: 0.3,
                        halign: "center",
                        fillColor: null
                    },
                    alternateRowStyles: {
                        fillColor: null
                    },
                    columnStyles: {
                        0: { cellWidth: 100 },
                        1: { cellWidth: 75, halign: "right" }
                    },
                    didDrawPage: (data) => {
                        currentY = data.table.finalY;
                    }
                });
                currentY = pdf.lastAutoTable.finalY + 12;
            }

            if (bankData) {
                pdf.setFont("Times", "italic");
                pdf.setFontSize(10);
                const paymentNote = "You can make the payment using the following bank details:";
                checkAddPage(10);
                pdf.text(paymentNote, marginX, currentY);
                currentY += 6;

                pdf.setFont("Times", "normal");
                pdf.setFontSize(10);

                const bankDetailsRows = [
                    [`Bank Name: ${bankData.bankName || "-"}`, `A/C Holder: ${bankData.accountHolderName || "-"}`],
                    [`A/C Number: ${bankData.accountNumber || "-"}`, `Account Type: ${bankData.accountType || "-"}`],
                    [`IFSC: ${bankData.ifscCode || "-"}`, `MICR: ${bankData.micrCode || "-"}`],
                    [`Branch Name: ${bankData.branchName || "-"}`, `Branch Address: ${bankData.branchAddress || "-"}`],
                ];

                const rowHeight = 6;
                const columnWidth = (pageWidth - 2 * marginX) / 2;

                for (const row of bankDetailsRows) {
                    checkAddPage(rowHeight);
                    pdf.text(row[0], marginX, currentY);
                    pdf.text(row[1], marginX + columnWidth, currentY);
                    currentY += rowHeight;
                }

                currentY += 6;
            }


            // const totalsHeight = 1;
            // checkAddPage(totalsHeight);




            const fileName = `FollowUp_${followUp.lead_name}_${new Date().toISOString().split('T')[0]}.pdf`;
            if (invoiceduty === "download") return pdf.save(fileName);
            if (invoiceduty === "preview") {
                window.open(pdf.output("bloburl"), "_blank");
            }
            if (invoiceduty === "send") {
                const pdfBlob = pdf.output('blob');
                const reader = new FileReader();
                reader.onloadend = async () => {
                    const base64PDF = reader.result.split(',')[1];
                    const payload = {
                        to: lead.email || '',
                        subject: dynamicSubject || `Follow-up Details - ${lead.lead_name}`,
                        message: emailContent || `\nPlease find the attached follow-up details.\n\nRegards,\n${companydata[0].companyname}`,
                        pdfBase64: base64PDF,
                        fileName,
                        lead, services, companydata, settings
                    };
                    await axios.post(`${process.env.REACT_APP_API_LINKS}/followupinvoices/sendinvoice`, payload, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                        withCredentials: true,
                    });
                    Swal.fire('Sent!', 'Follow-up details have been emailed.', 'success');
                };
                reader.readAsDataURL(pdfBlob);
            }
        } catch (err) {
            console.error(err);
            Swal.fire("Error", "Something went wrong!", "error");
        }
    };




    const markdemo = (leadid) => {
        const payload = { leadid: leadid }
        axios.post(`${process.env.REACT_APP_API_LINKS}/followups/addemo`, payload, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            withCredentials: true,
        })
            .then((res) => {
                if (res.status === 200) {
                    fetchFollowUps();
                    closemaildialogbox()
                    Swal.fire('Sent!', 'Sent for the demo.', 'success');

                }
                else if (res.status === 220) {
                    fetchFollowUps();
                    closemaildialogbox()
                    Swal.fire('Sent!', 'Already Sent for the demo.', 'info');

                }

            }).catch((err) => {
                console.log(err)
            })
    }



    const maildialogbox = (followUp) => {
        setSelectedFollowUp(followUp);

        setInvoicedialog(true);
    };

    const closemaildialogbox = () => {
        setInvoicedialog(false);
    };

    const handleFollowUpNameClick = (followUp) => {
        setSelectedFollowUp(followUp);
        setOpenCustomDialog(true);
    };

    const handleCloseCustomDialog = () => {
        setOpenCustomDialog(false);
        setSelectedFollowUp(null);
    };

    return (
        <Container
            disableGutters
            maxWidth={false}
        >
            <Box sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'column', lg: 'row' },
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 3,
                gap: 2
            }}>
                <TextField
                    placeholder="Search by Lead Name, Status, or Date"
                    size="small"
                    variant="outlined"
                    sx={{ minWidth: 310, width: { sm: '100%', md: '100%', lg: 500 } }}
                    value={searchQuery}
                    onChange={handleSearch}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                />
                <Box sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    alignItems: { xs: 'flex-start', sm: 'center' },
                    justifyContent: { md: 'space-between', sm: 'space-between' },
                    gap: 2,
                    width: { xs: '100%', sm: '100%', md: '100%' },
                }}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: { xs: 'row', sm: 'row' },
                        gap: { xs: 1, sm: 2 },
                        width: { xs: '100%', md: '100%', sm: '100%' },
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                    }}>
                        {permissions?.followup?.create && (
                            <Button
                                variant="contained"
                                startIcon={<AddIcon />}
                                onClick={() => {
                                    setFormData({
                                        companyid: companyid,
                                        leadId: '',
                                        followUpDate: null,
                                        followUpTime: '',
                                        assignedTo: '',
                                        status: '',
                                        notes: '',
                                        nextFollowUpDate: null,
                                        negotiate: 'No',
                                        wantAddServices: 'No',
                                        taxOption: 'including',
                                        roundOff: null,
                                        discount: 0,
                                        original_taxableAmount: 0,
                                        original_taxAmount: 0,
                                        original_totalAmount: 0,
                                        revised_taxableAmount: 0,
                                        revised_taxAmount: 0,
                                        revised_totalAmount: 0,
                                        services: [],
                                        revisedAmounts: []
                                    });
                                    setNegotiate('No');
                                    setNewDiscount(0);
                                    setSelectedLeadDiscount(0);
                                    setWantAddServices('No');
                                    setSelectedLead(null);
                                    setTaxOption('including');
                                    setRoundOff(0);
                                    setEditingFollowUpId(null);
                                    setOpenFollowUpDialog(true);
                                }}
                                sx={{
                                    backgroundColor: '#0b85c8',
                                    fontFamily: 'Open Sans',
                                    borderRadius: 2,
                                    whiteSpace: 'nowrap',
                                    minWidth: 'fit-content',
                                    width: { xs: '100%', sm: 'auto' }
                                }}
                            >
                                Add Follow-up
                            </Button>
                        )}
                        <Tooltip title="Export to Excel" arrow>
                            <IconButton onClick={exportToExcel}>
                                <DownloadIcon sx={{ color: '#0b85c8' }} />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Customize Columns" arrow>
                            <IconButton
                                onClick={() => setOpencolspaper(true)}
                                sx={{ color: '#0b85c8', padding: '8px' }}
                            >
                                <ViewColumnIcon />
                            </IconButton>
                        </Tooltip>
                        {opencolspaper && (
                            <Paper
                                elevation={3}
                                sx={{
                                    p: 2,
                                    zIndex: 1300,
                                    borderRadius: 2,
                                    position: 'absolute',
                                    top: { lg: '160px', xs: '255px', sm: '215px', md: '215px' },
                                    right: '25px',
                                    width: { xs: '280px', sm: '320px', md: '280px' },
                                    maxWidth: '320px',
                                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
                                }}
                            >
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                    <Typography
                                        variant="subtitle1"
                                        sx={{
                                            fontFamily: 'Open Sans',
                                            fontWeight: 600,
                                            color: '#0b85c8',
                                            fontSize: { xs: '13px', sm: '14px', md: '15px' },
                                        }}
                                    >
                                        Customize Columns
                                    </Typography>
                                    <IconButton onClick={() => setOpencolspaper(false)} size="small">
                                        <CloseIcon fontSize="small" />
                                    </IconButton>
                                </Box>

                                <Box sx={{ mb: 1 }}>
                                    <Button
                                        variant="text"
                                        onClick={() => {
                                            const allSelected = columns.every(column => !column.hide);

                                            if (allSelected) {
                                                const updatedColumns = columns.map(column => ({ ...column, hide: true }));
                                                setColumns(updatedColumns);
                                                setColumnOrder([]);
                                            } else {
                                                const updatedColumns = columns.map(column => ({ ...column, hide: false }));
                                                setColumns(updatedColumns);
                                                setColumnOrder(columns.map(column => column.field));
                                            }
                                        }}
                                        sx={{
                                            fontFamily: 'Open Sans',
                                            fontSize: { xs: '11px', sm: '12px', md: '13px' },
                                            textTransform: 'none',
                                            color: '#0b85c8',
                                            p: 0,
                                            minWidth: 'auto',
                                            '&:hover': {
                                                backgroundColor: 'transparent',
                                                textDecoration: 'underline'
                                            }
                                        }}
                                    >
                                        {columns.every(column => !column.hide) ? 'Unselect All' : 'Select All'}
                                    </Button>
                                </Box>

                                <Box sx={{ maxHeight: 200, overflowY: 'auto' }}>
                                    {columns.map((column) => (
                                        <Box key={column.field} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                            <Checkbox
                                                checked={!column.hide}
                                                onChange={(e) => {
                                                    const updatedColumns = columns.map((col) =>
                                                        col.field === column.field ? { ...col, hide: !e.target.checked } : col
                                                    );
                                                    setColumns(updatedColumns);
                                                    if (e.target.checked) {
                                                        setColumnOrder((prev) => {
                                                            if (!prev.includes(column.field)) {
                                                                return [...prev, column.field];
                                                            }
                                                            return prev;
                                                        });
                                                    } else {
                                                        setColumnOrder((prev) => prev.filter(field => field !== column.field));
                                                    }
                                                }}
                                                sx={{ mr: 1, p: 0.5 }}
                                            />
                                            <Typography
                                                sx={{
                                                    fontFamily: 'Open Sans',
                                                    fontSize: { xs: '12px', sm: '13px', md: '14px' },
                                                }}
                                            >
                                                {column.headerName || column.field}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Box>
                            </Paper>
                        )}
                    </Box>
                </Box>
            </Box>

            <Box sx={{ overflowX: 'auto', width: '100%' }}>
                <ReusableTable
                    columns={filteredColumns}
                    rows={filteredRows}
                    onEdit={handleEdit}
                    onDelete={handleDelete}
                    pdf={pdf}
                    onPdf={maildialogbox}
                    editicon={editicon}
                    deleteicon={deleteiocn}
                    onLeadNameClick={handleFollowUpNameClick}
                    onApplyFilters={(activeFilters) => {
                        setAppliedFilters(activeFilters);
                    }}
                    onPaginationChange={handlePaginationChange}
                    totalrows={totalrows}
                    popup={popup}
                    onSelectionChange={(ids) => setSelectedIds(ids)}
                />
            </Box>

            <Dialog open={invoicedialog} onClose={closemaildialogbox} maxWidth="xs" TransitionComponent={Grow} TransitionProps={{ timeout: 500 }}>
                {selectedFollowUp?.services?.length > 0 ? (<>
                    <DialogTitle sx={{ textAlign: 'center', fontFamily: 'Open Sans' }}>What would you like to do?</DialogTitle>
                    <DialogContent>



                        <Stack direction="row" spacing={3} justifyContent="center" mt={1}>
                            <Tooltip title="Send Mail">
                                <IconButton
                                    color="primary"
                                    onClick={() => {
                                        closemaildialogbox();
                                        handleOpenEmailDialog(selectedFollowUp);
                                    }}
                                >
                                    <MailOutlineIcon />
                                </IconButton>
                            </Tooltip>
                            {/* <Tooltip title="Whatsapp">
                                <IconButton
                                    color="green"
                                    onClick={() => {
                                        handlePdf(selectedFollowUp, 'whatsapp');
                                        closemaildialogbox();
                                    }}
                                >
                                    <WhatsAppIcon sx={{ color: 'green' }} />
                                </IconButton>
                            </Tooltip> */}
                            <Tooltip title="Preview PDF">
                                <IconButton
                                    color="info"
                                    onClick={() => {
                                        handlePdf(selectedFollowUp, 'preview');
                                        closemaildialogbox();
                                    }}
                                >
                                    <VisibilityIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Download PDF">
                                <IconButton
                                    color="info"
                                    onClick={() => {
                                        handlePdf(selectedFollowUp, 'download');
                                        closemaildialogbox();
                                    }}
                                >
                                    <DownloadIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Cancel">
                                <IconButton
                                    color="error"
                                    onClick={closemaildialogbox}
                                >
                                    <CancelIcon />
                                </IconButton>
                            </Tooltip>
                        </Stack>
                        <DialogActions>
                            <Button variant='contained' sx={{ mt: 3, background: '#017bcf', margin: 'auto', display: 'block' }} onClick={() => markdemo(selectedFollowUp.leadid)}>Mark for Demo</Button>
                        </DialogActions>

                    </DialogContent>
                </>) :
                    (<>
                        <DialogContent sx={{ textAlign: 'center', fontFamily: 'Open Sans', bgcolor: '#f0f9ff' }}>
                            This operation cannot be performed as no services have been added to this follow-up
                        </DialogContent>

                    </>)}
            </Dialog>

            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Dialog
                    open={openFollowUpDialog}
                    maxWidth="sm"
                    fullWidth
                    sx={{ borderRadius: 10 }}
                    TransitionComponent={Grow}
                    TransitionProps={{ timeout: 500 }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#f0f9ff' }}>
                        <DialogTitle
                            sx={{
                                fontFamily: 'Open Sans',
                                fontWeight: 600,
                                p: 2,
                                textAlign: 'center',
                                backgroundColor: '#f0f9ff',
                                display: 'flex',
                                justifyContent: 'center',
                                mt: 2,
                                color: '#0b85c8',
                                fontSize: { lg: '20px', xs: '10px', sm: '13px', md: '18px' },
                                margin: 'auto'
                            }}
                        >
                            {editingFollowUpId ? "Edit Follow-up Details" : "Add New Follow-up Details"}
                        </DialogTitle>
                        <IconButton onClick={() => setOpenFollowUpDialog(false)} sx={{ color: '#ffff' }}>
                            <CloseIcon sx={{ backgroundColor: '#0b85c8', fontSize: { lg: "24px" }, borderRadius: 2, color: '#fffff', mr: 2 }} />
                        </IconButton>
                    </Box>

                    <DialogContent sx={{ fontFamily: 'Open Sans', backgroundColor: '#f0f9ff', mt: -1 }}>
                        <Box sx={{ borderRadius: 2, boxShadow: '1px 1px 10px #888', fontFamily: 'Open Sans', padding: 2, backgroundColor: '#ffffff', ml: 1, position: 'relative', marginBottom: '15px' }}>
                            <Typography fontWeight={600} mb={1} mt={2} ml={2}>Follow-up Details</Typography>
                            <Grid container spacing={1} sx={{ display: 'flex', flexDirection: 'row', flexGrow: 1, justifyContent: 'center', mb: 2 }}>
                                <Autocomplete
                                    options={leadslist}
                                    getOptionLabel={(option) => `${option.lead_name} (${option.phone || 'No Mobile'})`}
                                    value={selectedLead}
                                    onChange={handleLeadSelect}
                                    sx={{ width: '100%' }}
                                    filterOptions={(options, { inputValue }) => {
                                        return options.filter(option =>
                                            option.lead_name.toLowerCase().includes(inputValue.toLowerCase()) ||
                                            (option.phone && option.phone.includes(inputValue))
                                        );
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Search Lead by Name or Mobile"
                                            size="small"
                                            fullWidth
                                            sx={{ width: { lg: '100%' } }}
                                            error={!!errors.leadId}
                                            helperText={errors.leadId}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Assigned To"
                                    value={formData.assignedTo}
                                    size="small"
                                    fullWidth
                                    sx={{ width: { lg: '100%' } }}
                                    disabled
                                />
                            </Grid>
                        </Box>

                        {formData.leadId && (
                            <Box sx={{ borderRadius: 2, boxShadow: '1px 1px 10px #888', fontFamily: 'Open Sans', padding: 2, backgroundColor: '#ffffff', ml: 1, position: 'relative', marginBottom: '15px' }}>
                                <Typography fontWeight={600} mb={1} mt={2} ml={2}>Services & Negotiation</Typography>
                                <FormControl sx={{ width: { lg: '96%', xs: '96%' }, ml: { lg: 3 } }}>
                                    <FormLabel sx={{ fontSize: { xs: '12px', fontWeight: 600 } }}>Do you want to add services?</FormLabel>
                                    <RadioGroup
                                        row
                                        value={wantAddServices}
                                        onChange={(e) => {
                                            setWantAddServices(e.target.value);
                                            setFormData({ ...formData, wantAddServices: e.target.value });
                                        }}
                                    >
                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                        <FormControlLabel value="No" control={<Radio />} label="No" />
                                    </RadioGroup>
                                </FormControl>

                                {wantAddServices === 'Yes' && (
                                    <Grid container spacing={1} sx={{ display: 'flex', flexDirection: 'row', flexGrow: 1, justifyContent: 'space-around', mb: 2 }}>
                                        <Autocomplete
                                            options={services}
                                            sx={{ width: '100%' }}
                                            getOptionLabel={(option) => option.service_name}
                                            onChange={handleServiceSelect}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Select Service"
                                                    size="small"
                                                    fullWidth
                                                    sx={{ width: '100%' }}
                                                />
                                            )}
                                        />
                                    </Grid>
                                )}

                                {formData.services.length > 0 && (
                                    <Box>
                                        <TableContainer component={Paper} sx={{ width: '100%', mt: 2, mb: 2 }}>
                                            <Table size="small">
                                                <TableHead>
                                                    <TableRow sx={{ fontFamily: 'Open Sans', textWrap: 'nowrap', textAlign: 'center' }}>
                                                        <TableCell sx={{ fontFamily: 'Open Sans', backgroundColor: '#f0f9ff', textAlign: 'center' }}>S.No.</TableCell>
                                                        <TableCell sx={{ fontFamily: 'Open Sans', backgroundColor: '#f0f9ff', textAlign: 'center' }}>Service Name</TableCell>
                                                        <TableCell sx={{ fontFamily: 'Open Sans', backgroundColor: '#f0f9ff', textAlign: 'center' }}>Original Duration</TableCell>
                                                        <TableCell sx={{ fontFamily: 'Open Sans', backgroundColor: '#f0f9ff', textAlign: 'center' }}>Opted Duration</TableCell>
                                                        <TableCell sx={{ fontFamily: 'Open Sans', backgroundColor: '#f0f9ff', textAlign: 'center' }}>Base Price</TableCell>
                                                        <TableCell sx={{ fontFamily: 'Open Sans', backgroundColor: '#f0f9ff', textAlign: 'center' }}>Taxable Amount</TableCell>
                                                        <TableCell sx={{ fontFamily: 'Open Sans', backgroundColor: '#f0f9ff', textAlign: 'center' }}>Tax Rate</TableCell>
                                                        <TableCell sx={{ fontFamily: 'Open Sans', backgroundColor: '#f0f9ff', textAlign: 'center' }}>Tax Amount</TableCell>
                                                        <TableCell sx={{ fontFamily: 'Open Sans', backgroundColor: '#f0f9ff', textAlign: 'center' }}>Total Amount</TableCell>
                                                        <TableCell sx={{ fontFamily: 'Open Sans', backgroundColor: '#f0f9ff', textAlign: 'center' }}>Start Date</TableCell>
                                                        <TableCell sx={{ fontFamily: 'Open Sans', backgroundColor: '#f0f9ff', textAlign: 'center' }}>End Date</TableCell>
                                                        <TableCell sx={{ fontFamily: 'Open Sans', backgroundColor: '#f0f9ff', textAlign: 'center' }}>Action</TableCell>
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                    {formData.services.map((service, index) => {
                                                        const serviceAmounts = calculateServiceAmount(service);
                                                        const pricePerDay = parseFloat(service.base_price) / parseInt(service.original_duration);

                                                        return (
                                                            <TableRow key={service.id} sx={{ fontFamily: 'Open Sans', textWrap: 'nowrap', textAlign: 'center' }}>
                                                                <TableCell sx={{ fontFamily: 'Open Sans' }}>{index + 1}</TableCell>
                                                                <TableCell sx={{ fontFamily: 'Open Sans' }}>{service.service_name}</TableCell>
                                                                <TableCell sx={{ fontFamily: 'Open Sans' }}>{service.original_duration} days</TableCell>
                                                                <TableCell sx={{ fontFamily: 'Open Sans' }}>
                                                                    {service.start_date && service.end_date ?
                                                                        `${Math.ceil((new Date(service.end_date) - new Date(service.start_date)) / (1000 * 60 * 60 * 24)) + 1} days` :
                                                                        service.original_duration + ' days'}
                                                                </TableCell>
                                                                <TableCell sx={{ fontFamily: 'Open Sans' }}>{service.base_price}</TableCell>
                                                                <TableCell sx={{ fontFamily: 'Open Sans' }}>{serviceAmounts.baseAmount}</TableCell>
                                                                <TableCell sx={{ fontFamily: 'Open Sans' }}>{service.tax_rate}%</TableCell>
                                                                <TableCell sx={{ fontFamily: 'Open Sans' }}>{serviceAmounts.taxAmount}</TableCell>
                                                                <TableCell sx={{ fontFamily: 'Open Sans' }}>{serviceAmounts.totalAmount}</TableCell>
                                                                <TableCell sx={{ fontFamily: 'Open Sans' }}>
                                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                        <DatePicker
                                                                            value={service.start_date}
                                                                            onChange={(date) => handleServiceDateChange(index, 'start_date', date)}
                                                                            inputFormat="dd/MM/yyyy"
                                                                            format='dd/MM/yyyy'
                                                                            slotProps={{
                                                                                textField: {
                                                                                    size: 'small',
                                                                                    sx: {
                                                                                        width: '100%',
                                                                                        '& .MuiInputBase-root': { height: 36 },
                                                                                        '& .MuiInputBase-input': { padding: '8px 10px', height: '20px' }
                                                                                    }
                                                                                }
                                                                            }}
                                                                        />
                                                                    </LocalizationProvider>
                                                                </TableCell>
                                                                <TableCell sx={{ fontFamily: 'Open Sans' }}>
                                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                        <DatePicker
                                                                            value={service.end_date}
                                                                            onChange={(date) => handleServiceDateChange(index, 'end_date', date)}
                                                                            inputFormat="dd/MM/yyyy"
                                                                            format='dd/MM/yyyy'
                                                                            slotProps={{
                                                                                textField: {
                                                                                    size: 'small',
                                                                                    sx: {
                                                                                        width: '100%',
                                                                                        '& .MuiInputBase-root': { height: 36 },
                                                                                        '& .MuiInputBase-input': { padding: '8px 10px', height: '20px' }
                                                                                    }
                                                                                }
                                                                            }}
                                                                        />
                                                                    </LocalizationProvider>
                                                                </TableCell>
                                                                <TableCell sx={{ fontFamily: 'Open Sans' }}>
                                                                    <IconButton onClick={() => removeService(service.id)}>
                                                                        <DeleteIcon color="error" />
                                                                    </IconButton>
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                        <Box>
                                            <Box>
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 5, mr: 3 }}>
                                                    <Box sx={{ textAlign: 'right' }}>Taxable Amount : </Box>
                                                    <Box sx={{ fontFamily: 'Open Sans', textAlign: 'right', width: '100px' }}>
                                                        {formData.original_taxableAmount.toFixed(2)}
                                                    </Box>
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 5, mr: 3, mb: 1 }}>
                                                    <Box sx={{ textAlign: 'right' }}>Tax Amount : </Box>
                                                    <Box sx={{ fontFamily: 'Open Sans', textAlign: 'right', width: '100px' }}>
                                                        {formData.original_taxAmount.toFixed(2)}
                                                    </Box>
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 5, mr: 3, mb: 1, mt: -1 }}>
                                                    <Box sx={{ textAlign: 'right' }}> Grand Total: </Box>
                                                    <Box sx={{ fontFamily: 'Open Sans', textAlign: 'right', width: '100px' }}>
                                                        {formData.original_totalAmount.toFixed(2)}
                                                    </Box>
                                                </Box>
                                            </Box>
                                            <Box sx={{ p: 1, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                                    <FormControl component="fieldset">
                                                        <FormLabel sx={{ fontSize: '12px', fontWeight: 600 }}>Do you want to negotiate?</FormLabel>
                                                        <RadioGroup
                                                            row
                                                            value={negotiate}
                                                            onChange={(e) => {
                                                                setNegotiate(e.target.value);
                                                                setFormData({ ...formData, negotiate: e.target.value });
                                                            }}
                                                        >
                                                            <FormControlLabel value="Yes" control={<Radio size="small" />} label="Yes" />
                                                            <FormControlLabel value="No" control={<Radio size="small" />} label="No" />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </Box>

                                                {negotiate === 'Yes' && (
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                                        <FormControl component="fieldset">
                                                            <FormLabel sx={{ fontSize: '12px', fontWeight: 600 }}>Tax Option</FormLabel>
                                                            <RadioGroup
                                                                row
                                                                value={taxOption}
                                                                onChange={(e) => {
                                                                    const newValue = e.target.value;
                                                                    setTaxOption(newValue);
                                                                    setFormData(prev => ({
                                                                        ...prev,
                                                                        taxOption: newValue
                                                                    }));
                                                                }}
                                                            >
                                                                <FormControlLabel value="including" control={<Radio size="small" />} label="Including Tax" />
                                                                <FormControlLabel value="excluding" control={<Radio size="small" />} label="Excluding Tax" />
                                                            </RadioGroup>
                                                        </FormControl>
                                                    </Box>
                                                )}

                                                {negotiate === 'Yes' && (
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                                        {/* <TextField
                                                                    label="Discount (%)"
                                                                    value={newDiscount}
                                                                    onChange={(e) => {
                                                                        const newValue = e.target.value;
                                                                        setNewDiscount(newValue);
                                                                        setFormData(prev => ({
                                                                            ...prev,
                                                                            discount: parseFloat(newValue) || 0
                                                                        }));
                                                                    }}
                                                                    type="number"
                                                                    size="small"
                                                                    sx={{ width: '150px' }}
                                                                /> */}
                                                        <TextField
                                                            label="Round Off Amount"
                                                            value={formData.roundOff}
                                                            onChange={(e) => {
                                                                const newValue = e.target.value;
                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    roundOff: newValue === '' ? 0 : parseFloat(newValue) || 0
                                                                }));
                                                            }}
                                                            type="number"
                                                            size="small"
                                                            sx={{ width: '150px' }}
                                                        />
                                                        <Box>
                                                            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                                                Amount to Pay: {formData.revised_totalAmount}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                )}

                                                {negotiate === 'Yes' && (
                                                    <Box sx={{ mt: 2 }}>
                                                        <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1, fontFamily: 'Open Sans', textAlign: 'center' }}>
                                                            Summary
                                                        </Typography>
                                                        <TableContainer component={Paper} sx={{ backgroundColor: '#f5f5f5', boxShadow: 'none' }}>
                                                            <Table size="small">
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontWeight: 'bold', fontSize: '12px' }}>
                                                                            Description
                                                                        </TableCell>
                                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontWeight: 'bold', fontSize: '12px', textAlign: 'right' }}>
                                                                            Amount
                                                                        </TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    <TableRow>
                                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontSize: '12px' }}>
                                                                            Original Taxable Amount
                                                                        </TableCell>
                                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontSize: '12px', textAlign: 'right' }}>
                                                                            {formData.original_taxableAmount.toFixed(2)}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                    <TableRow>
                                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontSize: '12px' }}>
                                                                            Original Tax Amount
                                                                        </TableCell>
                                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontSize: '12px', textAlign: 'right' }}>
                                                                            {formData.original_taxAmount.toFixed(2)}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                    <TableRow>
                                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontSize: '12px' }}>
                                                                            Original Total Amount
                                                                        </TableCell>
                                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontSize: '12px', textAlign: 'right' }}>
                                                                            {formData.original_totalAmount.toFixed(2)}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                    {/* <TableRow>
                                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontSize: '12px' }}>
                                                                            Discount ({formData.discount}%)
                                                                        </TableCell>
                                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontSize: '12px', textAlign: 'right' }}>
                                                                            {(formData.revised)).toFixed(2)}
                                                                        </TableCell>
                                                                    </TableRow> */}
                                                                    <TableRow>
                                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontSize: '12px' }}>
                                                                            Revised Taxable Amount
                                                                        </TableCell>
                                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontSize: '12px', textAlign: 'right' }}>
                                                                            {formData.revised_taxableAmount.toFixed(2)}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                    <TableRow>
                                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontSize: '12px' }}>
                                                                            Revised Tax Amount
                                                                        </TableCell>
                                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontSize: '12px', textAlign: 'right' }}>
                                                                            {formData.revised_taxAmount.toFixed(2)}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                    <TableRow>
                                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontSize: '12px', fontWeight: 'bold' }}>
                                                                            Final Total Amount
                                                                        </TableCell>
                                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>
                                                                            {formData.revised_totalAmount}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>
                                                    </Box>
                                                )}
                                            </Box>
                                        </Box>
                                    </Box>
                                    // </Box>
                                )}
                            </Box>
                        )}

                        <Box sx={{ borderRadius: 2, boxShadow: '1px 1px 10px #888', fontFamily: 'Open Sans', padding: 2, backgroundColor: '#ffffff', ml: 1, position: 'relative', marginBottom: '15px' }}>
                            <Typography fontWeight={600} mb={1} mt={2} ml={2}>Follow-up Information</Typography>
                            <Grid container spacing={1} sx={{ display: 'flex', flexDirection: 'row', flexGrow: 1, justifyContent: 'space-around', mb: 2 }}>
                                <DatePicker
                                    label="Follow-up Date"
                                    value={formData.followUpDate}
                                    onChange={(date) => handleDateChange('followUpDate', date)}
                                    sx={{ width: { lg: '48%', md: '49%', sm: '100%' } }}
                                    format='dd/MM/yyyy'
                                    slotProps={{
                                        textField: {
                                            size: 'small',
                                            error: !!errors.followUpDate,
                                            helperText: errors.followUpDate,
                                            sx: {
                                                '& .MuiInputBase-root': { height: 36 },
                                                width: { lg: '48%', md: '49%', sm: '100%' }
                                            }
                                        }
                                    }}
                                />
                                <TextField
                                    select
                                    label="Status"
                                    name="status"
                                    value={formData.status}
                                    onChange={handleInputChange}
                                    size="small"
                                    fullWidth
                                    sx={{ width: { lg: '48%', md: '49%', sm: '49%' } }}
                                    error={!!errors.status}
                                    helperText={errors.status}
                                >
                                    {leadStageData?.map((item) => (
                                        <MenuItem key={item.id} value={item.id}>{item.value}</MenuItem>
                                    ))}
                                </TextField>
                                <DatePicker
                                    label="Next Follow-up Date"
                                    value={formData.nextFollowUpDate}
                                    onChange={(date) => handleDateChange('nextFollowUpDate', date)}
                                    format="dd/MM/yyyy"
                                    sx={{ width: { lg: '48%', md: '49%', sm: '100%' } }}
                                    slotProps={{
                                        textField: {
                                            size: 'small',
                                            sx: {
                                                '& .MuiInputBase-root': { height: 36 },
                                                width: { lg: '48%', md: '49%', sm: '100%' }
                                            }
                                        }
                                    }}
                                />
                                <TextField
                                    fullWidth
                                    type='time'
                                    lable="Next Follow-up Time"
                                    value={formData.followUpTime}
                                    name='followUpTime'
                                    onChange={handleInputChange}
                                    sx={{
                                        width: { lg: '48%', md: '49%', sm: '100%', xs: '100%' },
                                        '& .MuiInputBase-root': { height: 40 },
                                    }}

                                />
                            </Grid>
                        </Box>

                        <Box sx={{ borderRadius: 2, boxShadow: '1px 1px 10px #888', fontFamily: 'Open Sans', padding: 2, backgroundColor: '#ffffff', ml: 1, position: 'relative', marginBottom: '15px' }}>
                            <Typography fontWeight={600} mb={1} mt={2} ml={2}>Notes and Comments</Typography>
                            <TextField
                                label="Notes"
                                name="notes"
                                value={formData.notes}
                                onChange={handleInputChange}
                                size="small"
                                multiline
                                rows={4}
                                fullWidth
                                sx={{ width: { lg: '100%' } }}
                            />
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Button
                                fullWidth
                                variant="contained"
                                sx={{ mt: 2, backgroundColor: '#0b85c8', fontFamily: 'Open Sans', width: 'max-content', margin: 'auto' }}
                                onClick={handleFollowUpSubmit}
                            >
                                {editingFollowUpId ? 'Update Follow-up' : 'Save Follow-up'}
                            </Button>
                        </Box>
                    </DialogContent>
                </Dialog>

                <Dialog
                    open={openPreview}
                    onClose={() => setOpenPreview(false)}
                    fullWidth
                    maxWidth="md"
                    sx={{ '& .MuiDialog-paper': { borderRadius: 2, overflow: 'hidden' } }}
                    TransitionComponent={Grow}
                    TransitionProps={{ timeout: 500 }}
                >
                    <DialogTitle sx={{ fontFamily: 'Open Sans', fontWeight: 600, textAlign: 'center', color: '#0b85c8', backgroundColor: '#f0f9ff' }}>
                        Follow-up Preview
                    </DialogTitle>
                    <DialogContent sx={{ height: '80vh', padding: 0, backgroundColor: '#f0f9ff', overflowY: 'auto' }}>
                        {previewUrl && (
                            <Box
                                className="a4-page"
                                sx={{
                                    width: "210mm",
                                    height: "297mm",
                                    margin: "auto",
                                    backgroundImage: `url(${background})`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    backgroundRepeat: "no-repeat",
                                    background: "white",
                                    boxShadow: "0 0 6px rgba(0,0,0,0.3)",
                                    fontFamily: "Times New Roman, Times, serif",
                                    color: "#000",
                                    padding: "20mm",
                                    boxSizing: "border-box",
                                    position: "relative",
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: '18px',
                                        fontWeight: 'bold',
                                        textAlign: 'center',
                                        marginTop: '20mm',
                                    }}
                                >
                                    Follow-up Details
                                </Typography>

                                <Box sx={{ marginTop: '20mm', display: 'flex', justifyContent: 'space-between' }}>
                                    <Box>
                                        <Typography sx={{ fontSize: '12px' }}>To:</Typography>
                                        <Typography sx={{ fontSize: '12px' }}>{selectedFollowUp?.lead_name || '-'}</Typography>
                                        <Typography sx={{ fontSize: '12px' }}>{selectedFollowUp?.full_name || '-'}</Typography>
                                        <Typography sx={{ fontSize: '12px' }}>{selectedFollowUp?.email || '-'}</Typography>
                                        <Typography sx={{ fontSize: '12px' }}>{selectedFollowUp?.phone || '-'}</Typography>
                                    </Box>
                                    <Box>
                                        <Typography sx={{ fontSize: '12px' }}>
                                            Follow-up Date: {selectedFollowUp?.display_followUpDate || '-'}
                                        </Typography>
                                        <Typography sx={{ fontSize: '12px' }}>
                                            Status: {selectedFollowUp?.status || '-'}
                                        </Typography>
                                        <Typography sx={{ fontSize: '12px' }}>
                                            Negotiate: {selectedFollowUp?.negotiate || 'No'}
                                        </Typography>
                                        <Typography sx={{ fontSize: '12px' }}>
                                            Tax Option: {selectedFollowUp?.taxOption || 'including'}
                                        </Typography>
                                    </Box>
                                </Box>

                                {selectedFollowUp?.notes && (
                                    <Box sx={{ marginTop: '5mm' }}>
                                        <Typography sx={{ fontSize: '12px', fontWeight: 'bold' }}>Notes:</Typography>
                                        <Typography sx={{ fontSize: '12px' }}>{selectedFollowUp.notes}</Typography>
                                    </Box>
                                )}

                                <TableContainer
                                    component={Paper}
                                    sx={{ marginTop: '10mm', width: '100%', backgroundColor: 'transparent', boxShadow: 'none', margin: 'center' }}
                                >
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                {['Service', 'Start Date', 'End Date', 'Days', 'Amount'].map((header, index) => (
                                                    <TableCell
                                                        key={header}
                                                        sx={{
                                                            fontFamily: 'Times New Roman, Times, serif',
                                                            fontWeight: 'bold',
                                                            fontSize: '12px',
                                                            backgroundColor: '#f0f9ff',
                                                            padding: '2mm',
                                                            width: index === 0 ? '28.5%' : index === 4 ? '19%' : '14.5%',
                                                            textAlign: index === 4 ? 'right' : 'left',
                                                        }}
                                                    >
                                                        {header}
                                                    </TableCell >
                                                ))}
                                            </TableRow >
                                        </TableHead >
                                        <TableBody>
                                            {selectedFollowUp.services?.map((service, index) => (
                                                <TableRow key={index}>
                                                    <TableCell sx={{ fontSize: '12px', padding: '2mm' }}>
                                                        {service.service_name || '-'}
                                                    </TableCell>
                                                    <TableCell sx={{ fontSize: '12px', padding: '2mm' }}>
                                                        {service.start_date?.split('T')[0] || '-'}
                                                    </TableCell>
                                                    <TableCell sx={{ fontSize: '12px', padding: '2mm' }}>
                                                        {service.end_date?.split('T')[0] || '-'}
                                                    </TableCell>
                                                    <TableCell sx={{ fontSize: '12px', padding: '2mm' }}>
                                                        {service.duration || '-'}
                                                    </TableCell>
                                                    <TableCell sx={{ fontSize: '12px', padding: '2mm', textAlign: 'right' }}>
                                                        {parseFloat(service.total_amount || 0).toFixed(2)}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table >
                                </TableContainer >

                                <Box sx={{ marginTop: '10mm', textAlign: 'right' }}>
                                    <Typography sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                                        Subtotal: {selectedFollowUp.services?.reduce((sum, s) => sum + parseFloat(s.total_amount || 0), 0).toFixed(2)}
                                    </Typography>
                                    <Typography sx={{ fontSize: '12px', fontWeight: 'bold', marginTop: '2mm' }}>
                                        Discount ({selectedFollowUp.discount || 0}%): {((selectedFollowUp.services?.reduce((sum, s) => sum + parseFloat(s.total_amount || 0), 0) * (parseFloat(selectedFollowUp.discount || 0) / 100))).toFixed(2)}
                                    </Typography>
                                    <Typography sx={{ fontSize: '14px', fontWeight: 'bold', marginTop: '2mm' }}>
                                        Total: {(selectedFollowUp.services?.reduce((sum, s) => sum + parseFloat(s.total_amount || 0), 0) * (1 - parseFloat(selectedFollowUp.discount || 0) / 100)).toFixed(2)}
                                    </Typography>
                                </Box>
                            </Box >
                        )}
                    </DialogContent >

                    <DialogActions sx={{ justifyContent: 'center', padding: 2 }}>
                        <Button
                            variant="contained"
                            color='success'
                            startIcon={<FileDownloadIcon />}
                            onClick={() => {
                                handlePdf(selectedFollowUp, 'download');
                                setOpenPreview(false);
                            }}>
                            Download
                        </Button>
                    </DialogActions>
                </Dialog >

                <Dialog
                    open={openCustomDialog}
                    onClose={handleCloseCustomDialog}
                    maxWidth="sm"
                    fullWidth
                    sx={{ borderRadius: 10 }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#f0f9ff' }}>
                        <DialogTitle
                            sx={{
                                fontFamily: 'Open Sans',
                                fontWeight: 600,
                                p: 2,
                                textAlign: 'center',
                                backgroundColor: '#f0f9ff',
                                display: 'flex',
                                justifyContent: 'center',
                                mt: 2,
                                color: '#0b85c8',
                                fontSize: { lg: '20px', xs: '10px', sm: '13px', md: '18px' },
                                margin: 'auto'
                            }}
                        >
                            {selectedFollowUp?.lead_name}
                        </DialogTitle>
                        <IconButton onClick={handleCloseCustomDialog} sx={{ color: '#ffff' }}>
                            <CloseIcon sx={{ backgroundColor: '#0b85c8', fontSize: { lg: '24px' }, borderRadius: 2, color: '#fffff', mr: 2 }} />
                        </IconButton>
                    </Box>
                    <DialogContent sx={{ fontFamily: 'Open Sans', backgroundColor: '#f0f9ff' }}>
                        {selectedFollowUp ? (
                            <Box sx={{ borderRadius: 10 }} >
                                <Accordion sx={{ mb: 2, borderRadius: 2, boxShadow: '1px 1px 10px #888' }} >
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        sx={{
                                            fontFamily: 'Open Sans',
                                            fontWeight: 600,
                                            fontSize: { lg: '14px', md: '12px', xs: '10px', sm: '11px' },
                                        }}
                                    >
                                        Follow-up Data
                                    </AccordionSummary>

                                    <AccordionDetails sx={{ mt: -2 }}>
                                        <TableContainer component={Paper}>
                                            <Table size="small">
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontWeight: 600, bgcolor: '#f0f9ff', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>
                                                            Lead Name
                                                        </TableCell>
                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>{selectedFollowUp.lead_name || '-'}</TableCell>
                                                    </TableRow>

                                                    <TableRow>
                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontWeight: 600, bgcolor: '#f0f9ff', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>Assigned To</TableCell>
                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>{selectedFollowUp.employee_name || '-'}</TableCell>
                                                    </TableRow>

                                                    <TableRow>
                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontWeight: 600, bgcolor: '#f0f9ff', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>Status</TableCell>
                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>{selectedFollowUp.status || '-'}</TableCell>
                                                    </TableRow>

                                                    <TableRow>
                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontWeight: 600, bgcolor: '#f0f9ff', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>Follow-up Date</TableCell>
                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>{selectedFollowUp.display_followUpDate || '-'}</TableCell>
                                                    </TableRow>

                                                    <TableRow>
                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontWeight: 600, bgcolor: '#f0f9ff', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>Next Follow-up Date</TableCell>
                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>{selectedFollowUp.display_nextFollowUpDate || '-'}</TableCell>
                                                    </TableRow>

                                                    <TableRow>
                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontWeight: 600, bgcolor: '#f0f9ff', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>
                                                            Services
                                                        </TableCell>
                                                        <TableCell sx={{ p: 1 }}>
                                                            {Array.isArray(selectedFollowUp.services) && selectedFollowUp.services.length > 0 ? (
                                                                selectedFollowUp.services.map((s, index) => (
                                                                    <TableContainer key={index} sx={{ width: '100%' }}>
                                                                        <Table size="small" sx={{ mb: 1, border: '1px solid #eee' }}>
                                                                            <TableBody>
                                                                                <TableRow sx={{ textWrap: 'none' }}>
                                                                                    <TableCell sx={{ fontWeight: 500, width: '30%', fontFamily: 'Open Sans', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' }, textWrap: 'none' }}>Service Name</TableCell>
                                                                                    <TableCell sx={{ fontFamily: 'Open Sans', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>{s.service_name || '-'}</TableCell>
                                                                                </TableRow>
                                                                                <TableRow sx={{ textWrap: 'none' }}>
                                                                                    <TableCell sx={{ fontWeight: 500, fontFamily: 'Open Sans', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' }, textWrap: 'none' }}>Duration</TableCell>
                                                                                    <TableCell sx={{ fontFamily: 'Open Sans', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>{s.duration || '-'}</TableCell>
                                                                                </TableRow>
                                                                                <TableRow sx={{ textWrap: 'none' }}>
                                                                                    <TableCell sx={{ fontWeight: 500, fontFamily: 'Open Sans', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' }, textWrap: 'none' }}>Start Date</TableCell>
                                                                                    <TableCell sx={{ fontFamily: 'Open Sans', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>{s.display_start_date || '-'}</TableCell>
                                                                                </TableRow>
                                                                                <TableRow sx={{ textWrap: 'none' }}>
                                                                                    <TableCell sx={{ fontWeight: 500, fontFamily: 'Open Sans', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' }, textWrap: 'none' }}>End Date</TableCell>
                                                                                    <TableCell sx={{ fontFamily: 'Open Sans', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>{s.display_end_date || '-'}</TableCell>
                                                                                </TableRow>
                                                                            </TableBody>
                                                                        </Table>
                                                                    </TableContainer>
                                                                ))
                                                            ) : (
                                                                '-'
                                                            )}
                                                        </TableCell>
                                                    </TableRow>

                                                    <TableRow>
                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontWeight: 600, bgcolor: '#f0f9ff', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>Notes</TableCell>
                                                        <TableCell
                                                            onClick={() => setExpand(expand === selectedFollowUp.id ? null : selectedFollowUp.id)}
                                                            sx={{
                                                                fontFamily: 'Open Sans',
                                                                fontSize: '11px',
                                                                whiteSpace: expand === selectedFollowUp.id ? 'normal' : 'nowrap',
                                                                textWrap: expand === selectedFollowUp.id ? 'wrap' : 'nowrap',
                                                                width: '100px',
                                                                maxWidth: '100px',
                                                                minWidth: '100px',
                                                                overflow: 'hidden',
                                                                cursor: 'pointer',
                                                                textOverflow: expand !== selectedFollowUp.id ? 'clip' : 'ellipsis',
                                                            }}
                                                        >
                                                            {selectedFollowUp.notes || '-'}
                                                        </TableCell>
                                                    </TableRow>

                                                    <TableRow>
                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontWeight: 600, bgcolor: '#f0f9ff', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>Created On</TableCell>
                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>{selectedFollowUp.display_created_on || '-'}</TableCell>
                                                    </TableRow>

                                                    <TableRow>
                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontWeight: 600, bgcolor: '#f0f9ff', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>Updated On</TableCell>
                                                        <TableCell sx={{ fontFamily: 'Open Sans', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>{selectedFollowUp.display_updated_on || '-'}</TableCell>
                                                    </TableRow>

                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </AccordionDetails>
                                </Accordion>

                                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                                    <Button
                                        variant="contained"
                                        sx={{ backgroundColor: '#0b85c8', fontFamily: 'Open Sans' }}
                                        onClick={handleCloseCustomDialog}
                                    >
                                        Close
                                    </Button>
                                </Box>
                            </Box>
                        ) : (
                            <Typography sx={{ fontFamily: 'Open Sans' }}>No follow-up selected</Typography>
                        )}
                    </DialogContent>
                </Dialog>
                <Dialog
                    open={openEmailDialog}
                    onClose={handleCloseEmailDialog}
                    maxWidth="sm"
                    fullWidth
                    sx={{ '& .MuiDialog-paper': { borderRadius: 2 } }}
                    TransitionComponent={Grow}
                    TransitionProps={{ timeout: 500 }}
                >
                    <DialogTitle sx={{ fontFamily: 'Open Sans', fontWeight: 600, textAlign: 'center', color: '#0b85c8', backgroundColor: '#f0f9ff' }}>
                        Compose Email
                    </DialogTitle>
                    <DialogContent sx={{ fontFamily: 'Open Sans', backgroundColor: '#f0f9ff', pt: 2 }}>
                        <TextField
                            label="Subject"
                            value={emailSubject}
                            onChange={(e) => setEmailSubject(e.target.value)}
                            fullWidth
                            size="small"
                            sx={{ mb: 2 }}
                        />
                        <TextField
                            label="Email Content"
                            value={emailContent}
                            onChange={(e) => setEmailContent(e.target.value)}
                            fullWidth
                            multiline
                            rows={6}
                            size="small"
                            sx={{ mb: 2 }}
                        />
                    </DialogContent>
                    <DialogActions sx={{ justifyContent: 'center', backgroundColor: '#f0f9ff', pb: 2 }}>
                        <Button
                            variant="contained"
                            startIcon={<SendIcon />}
                            onClick={handleSendEmail}
                            sx={{ backgroundColor: '#0b85c8', fontFamily: 'Open Sans' }}
                        >
                            Send Email
                        </Button>
                        <Button
                            variant="outlined"
                            startIcon={<CancelIcon />}
                            onClick={handleCloseEmailDialog}
                            sx={{ fontFamily: 'Open Sans', color: '#0b85c8', borderColor: '#0b85c8' }}
                        >
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
            </LocalizationProvider >
        </Container >
    );
}